import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from "recharts";
import { inr } from "../lib/api";

export const short = (n) => (n >= 1e7 ? `₹${(n / 1e7).toFixed(1)}Cr` : n >= 1e5 ? `₹${(n / 1e5).toFixed(1)}L` : n >= 1e3 ? `₹${(n / 1e3).toFixed(0)}K` : `₹${n}`);

export const BooksChart = ({ sites }) => (
  <div className="rounded-2xl border border-line bg-surface p-4 sm:p-6 rise" data-testid="books-chart">
    <h2 className="font-display text-base md:text-lg font-semibold mb-4">Book-wise Deposit &amp; Withdraw</h2>
    {sites.length === 0 ? (
      <p className="text-sm text-muted-c py-10 text-center">No books yet</p>
    ) : (
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%" minWidth={200} minHeight={200}>
          <BarChart data={sites} margin={{ top: 20, right: 8, left: 0, bottom: 0 }} barGap={6}>
            <defs>
              <linearGradient id="gDep" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#34d399" /><stop offset="100%" stopColor="#059669" /></linearGradient>
              <linearGradient id="gWd" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#f87171" /><stop offset="100%" stopColor="#b91c1c" /></linearGradient>
            </defs>
            <CartesianGrid stroke="rgb(var(--t-line))" vertical={false} />
            <XAxis dataKey="name" tick={{ fill: "rgb(var(--t-brand))", fontSize: 12 }} axisLine={false} tickLine={false} interval={0} />
            <YAxis tickFormatter={short} tick={{ fill: "rgb(var(--t-muted))", fontSize: 11 }} axisLine={false} tickLine={false} width={56} />
            <Tooltip cursor={{ fill: "rgba(255,255,255,0.04)" }} formatter={(v) => inr(v)}
              contentStyle={{ background: "rgb(var(--t-surface))", border: "1px solid rgb(var(--t-line2))", borderRadius: 8, color: "rgb(var(--t-ink))" }} />
            <Legend wrapperStyle={{ fontSize: 12, color: "rgb(var(--t-ink2))" }} />
            <Bar dataKey="total_deposit" name="Deposit" fill="url(#gDep)" radius={[6, 6, 0, 0]} maxBarSize={48}
              label={{ position: "top", fill: "rgb(var(--t-ink))", fontSize: 11, formatter: short }} />
            <Bar dataKey="total_withdraw" name="Withdraw" fill="url(#gWd)" radius={[6, 6, 0, 0]} maxBarSize={48}
              label={{ position: "top", fill: "rgb(var(--t-ink))", fontSize: 11, formatter: short }} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    )}
  </div>
);
